import React, { FC } from 'react';
import './styles.scss';

interface IRadioButtonProps {
  label: string;
  value: string;
  name: string;
  checked?: boolean;
  className?: string;
  onChange: (value: string) => void;
}

const RadioInput: FC<IRadioButtonProps> = ({
  label,
  value,
  name,
  checked = false,
  className,
  onChange,
}) => (
  <div>
    <label className={`radio-label ${className}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className="custom-radio"
      />
      {label}
    </label>
  </div>
);

export default RadioInput;
